import { Plus } from 'lucide-react';
import { Button } from '@sara/ui/components/button';
import { useDialog } from '@sara/ui/hooks/use-dialog';
import { useActiveOrganization } from '../../contexts/auth';
import { CreateDomainDialog, DomainListContainer } from '../../contexts/domains';
import { PageHeader } from '../../components/page-header';

export function DomainsSettingsPage() {
  const { organization } = useActiveOrganization();
  const createDialog = useDialog(CreateDomainDialog);

  if (!organization) return null;

  return (
    <div className="space-y-12">
      <PageHeader
        title="Custom domains"
        description="Brand the candidate-facing interview link with your own hostname. Each domain pair (interview + API) requires DNS CNAME records and certificates issued before it activates."
        action={
          <Button
            variant="tinted"
            shape="pill"
            size="sm"
            className="h-8 gap-1.5 px-3 text-xs [&_svg]:size-3.5 sm:h-9 sm:px-4 sm:text-sm sm:[&_svg]:size-4"
            onClick={() => createDialog.open({ orgId: organization.id })}
          >
            <Plus strokeWidth={1.6} />
            Add custom domain
          </Button>
        }
      />

      <section>
        <DomainListContainer
          orgId={organization.id}
          onCreate={() => createDialog.open({ orgId: organization.id })}
        />
      </section>
    </div>
  );
}
